export var ACTION;
(function (ACTION) {
    ACTION["PLEDGE_CONFIRMATION"] = "PLEDGE_CONFIRMATION";
    ACTION["BACK_BUTTON"] = "BACK_BUTTON";
    ACTION["NAV_TO_FAQ"] = "NAV_TO_FAQ";
    ACTION["SEND_OTP_FOR_PLEDGE_CONFIRM"] = "SEND_OTP_FOR_PLEDGE_CONFIRM";
    ACTION["ON_PAGE_LOAD"] = "ON_PAGE_LOAD";
    ACTION["NEED_HELP"] = "NEED_HELP";
    ACTION["GO_TO_KFS"] = "GO_TO_KFS";
    ACTION["GO_TO_STATE_SELECTION_PAGE"] = "GO_TO_STATE_SELECTION_PAGE";
    ACTION["TRIGGER_CAMS_FETCH"] = "TRIGGER_CAMS_FETCH";
    ACTION["TRIGGER_KARVY_FETCH"] = "TRIGGER_KARVY_FETCH";
    ACTION["VERIFY_CAMS_FETCH"] = "VERIFY_CAMS_FETCH";
    ACTION["INIT_PLEDGE"] = "INIT_PLEDGE";
    ACTION["VERIFY_PLEDGE"] = "VERIFY_PLEDGE";
})(ACTION || (ACTION = {}));
